var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6423 15.6621L16.2972 18.0151C15.3462 18.9694 13.673 18.99 12.7015 18.0151L10.3563 15.6621L1.93359 24.1122C2.24712 24.2572 2.5928 24.3437 2.9603 24.3437H26.0384C26.4059 24.3437 26.7515 24.2573 27.0649 24.1123L18.6423 15.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0383 4.65625H2.96019C2.59269 4.65625 2.24701 4.74277 1.93359 4.88774L10.9339 13.9179C10.9345 13.9185 10.9352 13.9186 10.9358 13.9192C10.9364 13.9198 10.9365 13.9206 10.9365 13.9206L13.863 16.8568C14.1739 17.1677 14.8247 17.1677 15.1356 16.8568L18.0615 13.9211C18.0615 13.9211 18.0622 13.9198 18.0628 13.9192C18.0628 13.9192 18.0641 13.9185 18.0647 13.9179L27.0648 4.88769C26.7514 4.74266 26.4058 4.65625 26.0383 4.65625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.761734 6.03491C0.599531 6.36293 0.5 6.72704 0.5 7.11707V21.8827C0.5 22.2727 0.599422 22.6368 0.76168 22.9648L9.19903 14.5002L0.761734 6.03491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.238 6.03491L19.8008 14.5003L28.238 22.9651C28.4002 22.6371 28.4998 22.2729 28.4998 21.8828V7.11718C28.4998 6.72704 28.4002 6.36293 28.238 6.03491Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.b0daed4c9df0a77a1b6857eadd24951c.svg";
export { ForwardRef as ReactComponent };